import React from "react";
import Profile from "../Profile";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import arrowDown from "@assets/images/chevron-right.svg";
import { getUserType } from "@store/userType";
import { Link, useHistory } from "react-router-dom";
import { deleteFromStorage, getFromStorage } from "utils/storage";
import useSize from "hooks/common/useSize";
import { useEffect } from "react";
import { commonData } from "data/CommonDataPoint";
import { generalStore } from "store/generalStore";

function Menu({ isMenuOpenMobile, isMenuOpen }) {
  const history = useHistory();
  const isUserType = getUserType((state) => state.isUserType);
  const verifyBookingAndFormLoader = generalStore(
    (state) => state.verifyBookingAndFormLoader,
  );
  const winDimensions = useSize();

  const handleSignOut = () => {
    // history.push("/login");
    deleteFromStorage("user_data");
  };

  const handleMenuClick = () => {
    if (winDimensions[0] <= 768) {
      document.body.classList.remove("cm-overflow-hidden");
    }
    if (getFromStorage("unConfirm_Booking")) {
      deleteFromStorage("unConfirm_Booking");
      deleteFromStorage("unConfirmBooking_Time");
      deleteFromStorage("confirmBooking_Status");
    }
  };

  const handleRemoveMouseEnter = (item, hoveredItem) => {
    const itemRect = item.getBoundingClientRect();
    const parentRect = item.parentNode.getBoundingClientRect();

    const topOffset = itemRect.top - parentRect.top;
    const leftOffset = itemRect.right - parentRect.left;

    const itemText = item.querySelector(".menu-link-text").textContent;
    hoveredItem.textContent = itemText;
    hoveredItem.style.display = "none";

    hoveredItem.style.top = `${topOffset}px`;
    hoveredItem.style.left = `${leftOffset}px`;
  };

  /** Menu hover State functionality start **/
  useEffect(() => {
    const parentUl = document.getElementById("main-side-nav");
    const hoveredItem = document.getElementById("hover-text");

    const handleMouseEnter = (item) => {
      const itemRect = item.getBoundingClientRect();
      const parentRect = item.parentNode.getBoundingClientRect();

      const topOffset = itemRect.top - parentRect.top;
      const leftOffset = itemRect.right - parentRect.left;

      const itemText = item.querySelector(".menu-link-text").textContent;
      hoveredItem.textContent = itemText;
      hoveredItem.style.display = "block";

      hoveredItem.style.top = `${topOffset}px`;
      hoveredItem.style.left = `${leftOffset}px`;
    };

    const handleMouseLeave = () => {
      hoveredItem.style.display = "none";
    };

    const menuItems = parentUl.querySelectorAll(".menu-item");

    if (!isMenuOpen) {
      menuItems.forEach((item) => {
        item.addEventListener("mouseenter", () => {
          handleMouseEnter(item);
        });

        item.addEventListener("mouseleave", () => {
          hoveredItem.style.display = "none";
        });
      });
    } else {
      menuItems.forEach((item) => {
        item.removeEventListener("mouseenter", () =>
          handleRemoveMouseEnter(item, hoveredItem),
        );
        item.removeEventListener("mouseleave", handleMouseLeave);
      });
    }
  }, [isMenuOpen]);

  /** Menu hover State functionality end **/
  // const disableMenu = false;
  return (
    // <nav className={`bs-menu ${!isMenuOpenMobile ? "menu-active" : ""}`}>
    <nav
      className={`bs-menu ${!isMenuOpenMobile ? "menu-active" : ""} ${
        verifyBookingAndFormLoader ? "menu-disabled" : ""
      }`}
    >
      {/* <ul className="menu-wrap cm-visible-sm">
        <li className="menu-item">
          <Profile />
        </li>
      </ul> */}
      <ul className="menu-wrap cm-scrollbar" id="main-side-nav">
        {isUserType === commonData?.admin ? (
          <>
            <li className="menu-item">
              <Link
                to={`/${isUserType}/dashboard`}
                className={`menu-link ${
                  history.location.pathname === `/${isUserType}/dashboard`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname === `/${isUserType}/dashboard`
                      ? "icon-home-f"
                      : "icon-home"
                  }`}
                ></span>
                <span className="menu-link-text">Home</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType}/project-listing`}
                className={`menu-link ${
                  history.location.pathname === `/${isUserType}/project-listing`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType}/project-listing`
                      ? "icon-project-city-f"
                      : "icon-project-city"
                  }`}
                ></span>

                <span className="menu-link-text">Projects</span>
              </Link>
            </li>

            {/* <li className="menu-item">
              <Link
                // to={`/${isUserType?.replace(/\s/g, "")}/choose-apartment`}
                to={{
                  pathname: `/${isUserType?.replace(
                    /\s/g,
                    ""
                  )}/choose-apartment`,
                  state: { isInventory: true },
                }}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/choose-apartment`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/choose-apartment`
                      ? "icon-apartment-f"
                      : "icon-apartment"
                  }`}
                ></span>
                <span className="menu-link-text">Inventory</span>
              </Link>
            </li> */}
            {/* <li className="menu-item">
              <Link to={`/${isUserType}/apartment-view-details`} className={`menu-link ${history.location.pathname === `/${isUserType}/apartment-view-details`
                ? "active"
                : ""
                }`}>
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname === `/${isUserType}/apartment-view-details`
                      ? "icon-apartment-f"
                      : "icon-apartment"
                  }`}
                ></span>
                <span className="menu-link-text">Apartments</span>
              </Link>
            </li>

            <li  className="menu-item">
              <Link to={`/${isUserType}/payment`} className={`menu-link ${history.location.pathname === `/${isUserType}/payment`
                ? "active"
                : ""
                }`}>
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname === `/${isUserType}/payment`
                      ? "icon-wallet-f"
                      : "icon-wallet"
                  }`}
                ></span>
                <span className="menu-link-text">Payments</span>
              </Link>
            </li> */}

            <li className="menu-item">
              <Link
                to={`/${isUserType}/user`}
                className={`menu-link ${
                  history.location.pathname === `/${isUserType}/user`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname === `/${isUserType}/user`
                      ? "icon-user-request-f"
                      : "icon-user-request"
                  }`}
                ></span>
                <span className="menu-link-text">Users</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType}/customers`}
                className={`menu-link ${
                  history.location.pathname === `/${isUserType}/customers`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname === `/${isUserType}/customers`
                      ? "icon-user-f"
                      : "icon-user"
                  }`}
                ></span>
                <span className="menu-link-text">Customers</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/assign-customer`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/assign-customer`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/assign-customer`
                      ? "icon-user-f"
                      : "icon-user"
                  }`}
                ></span>
                <span className="menu-link-text">Assign Customers</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/apartment-listing`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/apartment-listing`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/apartment-listing`
                      ? "icon-apartment-f"
                      : "icon-apartment"
                  }`}
                ></span>
                <span className="menu-link-text">Apartments</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType}/booking`}
                className={`menu-link ${
                  history.location.pathname === `/${isUserType}/booking`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname === `/${isUserType}/booking`
                      ? "icon-booking-f"
                      : "icon-booking"
                  }`}
                ></span>
                <span className="menu-link-text">Bookings</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType}/ebwlist`}
                className={`menu-link ${
                  history.location.pathname === `/${isUserType}/ebwlist`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname === `/${isUserType}/ebw-list`
                      ? "icon-ebw-list-f"
                      : "icon-ebw-list"
                  }`}
                ></span>
                <span className="menu-link-text">EBW Lists</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/payment`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/payment`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/payment`
                      ? "icon-wallet-f"
                      : "icon-wallet"
                  }`}
                ></span>
                <span className="menu-link-text">Payments</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType}/customer-search`}
                className={`menu-link ${
                  history.location.pathname === `/${isUserType}/customer-search`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType}/customer-search`
                      ? "icon-user-f"
                      : "icon-user"
                  }`}
                ></span>
                <span className="menu-link-text">Customer search</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType}/customer`}
                className={`menu-link ${
                  history.location.pathname === `/${isUserType}/customer`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname === `/${isUserType}/customer`
                      ? "icon-user-f"
                      : "icon-user"
                  }`}
                ></span>
                <span className="menu-link-text">Leads</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType}/user-request`}
                className={`menu-link ${
                  history.location.pathname === `/${isUserType}/user-request`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname === `/${isUserType}/user-request`
                      ? "icon-user-request-f"
                      : "icon-user-request"
                  }`}
                ></span>
                <span className="menu-link-text">User Requests</span>
              </Link>
            </li>

            {/* <li className="menu-item">
            <Link to="/customer-details" className="menu-link">
              <span className="menu-link-icon icon icon-project-city"></span>
              <span className="menu-link-text">Customer Details</span>
            </Link>
          </li> */}

            <li className="menu-item sub-menu">
              <Accordion className="sub-menu-wrap">
                <AccordionSummary
                  expandIcon={
                    <span className="sub-menu-expand-icon icon-chevron-down"></span>
                  }
                  aria-controls="panel1-content"
                  id="panel1-header"
                  className="sub-menu-head"
                >
                  <Link className="menu-link">
                    <span className="menu-link-icon icon icon-menu"></span>
                    <span className="menu-link-text">More</span>
                  </Link>
                </AccordionSummary>
                <AccordionDetails className="sub-menu-cont">
                  <ul className="menu-wrap">
                    <li className="menu-item">
                      <Link
                        to={`/${isUserType?.replace(/\s/g, "")}/banklist`}
                        // className="menu-link"
                        className={`menu-link ${
                          history.location.pathname ===
                          `/${isUserType?.replace(/\s/g, "")}/banklist`
                            ? "active"
                            : ""
                        }`}
                        onClick={handleMenuClick}
                      >
                        <span className="menu-link-text">Bank's List</span>
                      </Link>
                    </li>
                    {/* <li className="menu-item">
                      <Link
                        to={`/${isUserType?.replace(/\s/g, "")}/sms-email`}
                        className="menu-link"
                      >
                        <span className="menu-link-text">SMS - Email (Project Wise)</span>
                      </Link>
                    </li>
                    <li className="menu-item">
                      <Link
                        to={`/${isUserType?.replace(/\s/g, "")}/sms-email-generic`}
                        className="menu-link"
                      >
                        <span className="menu-link-text">SMS - Email (Generic)</span>
                      </Link>
                    </li> */}
                  </ul>
                </AccordionDetails>
              </Accordion>
            </li>
            <li className="menu-item sub-menu">
              <Accordion className="sub-menu-wrap">
                <AccordionSummary
                  expandIcon={
                    <span className="sub-menu-expand-icon icon-chevron-down"></span>
                  }
                  aria-controls="panel1-content"
                  id="panel1-header"
                  className="sub-menu-head"
                >
                  <Link className="menu-link">
                    <span className="menu-link-icon icon icon-menu"></span>
                    <span className="menu-link-text">SMS - Email</span>
                  </Link>
                </AccordionSummary>
                <AccordionDetails className="sub-menu-cont">
                  <ul className="menu-wrap">
                    {/* <li className="menu-item">
                      <Link
                        to={`/${isUserType?.replace(/\s/g, "")}/banklist`}
                        className="menu-link"
                      >
                        <span className="menu-link-text">Bank's List</span>
                      </Link>
                    </li> */}
                    <li className="menu-item">
                      <Link
                        to={`/${isUserType?.replace(/\s/g, "")}/sms-email`}
                        // className="menu-link"
                        className={`menu-link ${
                          history.location.pathname ===
                          `/${isUserType?.replace(/\s/g, "")}/sms-email`
                            ? "active"
                            : ""
                        }`}
                        onClick={handleMenuClick}
                      >
                        <span className="menu-link-text">Project Wise</span>
                      </Link>
                    </li>
                    <li className="menu-item">
                      <Link
                        to={`/${isUserType?.replace(
                          /\s/g,
                          "",
                        )}/sms-email-generic`}
                        // className="menu-link"
                        className={`menu-link ${
                          history.location.pathname ===
                          `/${isUserType?.replace(/\s/g, "")}/sms-email-generic`
                            ? "active"
                            : ""
                        }`}
                        onClick={handleMenuClick}
                      >
                        <span className="menu-link-text">Generic</span>
                      </Link>
                    </li>
                  </ul>
                </AccordionDetails>
              </Accordion>
            </li>
          </>
        ) : null}
        {isUserType === "Customer" ? (
          <>
            <li className="menu-item">
              <Link
                to={`/${isUserType}/user-dashboard`}
                className={`menu-link ${
                  history.location.pathname === `/${isUserType}/user-dashboard`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType}/user-dashboard`
                      ? "icon-home-f"
                      : "icon-home"
                  }`}
                ></span>
                <span className="menu-link-text">Home</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType}/project-listing`}
                className={`menu-link ${
                  history.location.pathname === `/${isUserType}/project-listing`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType}/project-listing`
                      ? "icon-project-city-f"
                      : "icon-project-city"
                  }`}
                ></span>
                <span className="menu-link-text">Projects</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType}/ebw-list`}
                className={`menu-link ${
                  history.location.pathname === `/${isUserType}/ebw-list`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname === `/${isUserType}/ebw-list`
                      ? "icon-ebw-list-f"
                      : "icon-ebw-list"
                  }`}
                ></span>
                <span className="menu-link-text">EBW List</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType}/bookings`}
                className={`menu-link ${
                  history.location.pathname === `/${isUserType}/bookings`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname === `/${isUserType}/bookings`
                      ? "icon-booking-f"
                      : "icon-booking"
                  }`}
                ></span>
                <span className="menu-link-text">Bookings</span>
              </Link>
            </li>
            {/* <li className="menu-item">
              <Link
                to={`/${isUserType}/manage-applicants`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType}/manage-applicants`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType}/manage-applicants`
                      ? "icon-manage-applicant-f"
                      : "icon-manage-applicant"
                  }`}
                ></span>
                <span className="menu-link-text">Manage Applicants</span>
              </Link>
            </li> */}
            <li className="menu-item">
              <Link
                to={`/${isUserType}/payment`}
                className={`menu-link ${
                  history.location.pathname === `/${isUserType}/payment`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname === `/${isUserType}/payment`
                      ? "icon-wallet-f"
                      : "icon-wallet"
                  }`}
                ></span>
                <span className="menu-link-text">Payments</span>
              </Link>
            </li>
            {/* <li className="menu-item sub-menu">
                <Accordion
                  className="sub-menu-wrap"
                  defaultExpanded={
                    history.location.pathname === "/document-list" ? true : false
                  }
                >
                  <AccordionSummary
                    expandIcon={
                      <span className="sub-menu-expand-icon">
                        <img src={arrowDown} />
                      </span>
                    }
                    aria-controls="panel1-content"
                    id="panel1-header"
                    className="sub-menu-head"
                  >
                    <a href="#" className="menu-link">
                      <span className="menu-link-icon icon icon-project-city"></span>
                      <span className="menu-link-text">More</span>
                    </a>
                  </AccordionSummary>
                  <AccordionDetails className="sub-menu-cont">
                    <ul className="menu-wrap">
                      <li className="menu-item">
                        <a
                          href="/document-list"
                          className={`menu-link ${history.location.pathname === "/document-list"
                            ? "active"
                            : ""
                            }`}
                        >
                          <span className="menu-link-icon icon icon-project-city"></span>
                          <span className="menu-link-text">Document</span>
                        </a>
                      </li>
                    </ul>
                  </AccordionDetails>
                </Accordion>
              </li> */}
          </>
        ) : null}
        {isUserType === "GRE" ? (
          <>
            <li className="menu-item">
              <Link
                to={`/${isUserType}/customer-search`}
                className={`menu-link ${
                  history.location.pathname === `/${isUserType}/customer-search`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType}/customer-search`
                      ? "icon-home-f"
                      : "icon-home"
                  }`}
                ></span>
                <span className="menu-link-text">Home</span>
              </Link>
            </li>
            {/* <li className="menu-item">
              <Link
                to={`/${isUserType}/customers`}
                className={`menu-link ${
                  history.location.pathname === `/${isUserType}/customers`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname === `/${isUserType}/customers`
                      ? "icon-user-f"
                      : "icon-user"
                  }`}
                ></span>
                <span className="menu-link-text">Customer</span>
              </Link>
            </li> */}
            {/* <li className="menu-item">
              <a
                href="/email"
                className={`menu-link ${history.location.pathname === `/${isUserType}/email` ? "active" : ""
                  }`}
              >
                <span
                  className={`menu-link-icon icon ${history.location.pathname === `/${isUserType}/email`
                    ? "icon-email-f"
                      : "icon-email"
                    }`}
                ></span>
                <span className="menu-link-text">Email</span>
              </a>
            </li>
            <li className="menu-item">
              <a
                href="/sms"
                className={`menu-link ${history.location.pathname === history.location.pathname === `/${isUserType}/sms` ? "active" : ""
                  }`}
              >
                <span
                  className={`menu-link-icon icon ${history.location.pathname === history.location.pathname === `/${isUserType}/sms`
                    ? "icon-message-f"
                      : "icon-message"
                    }`}
                ></span>
                <span className="menu-link-text">SMS</span>
              </a>
            </li> */}
          </>
        ) : null}
        {isUserType?.replace(/\s/g, "") == commonData?.closingTeamLeadRole ? (
          <>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/dashboard`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/dashboard`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/dashboard`
                      ? "icon-home-f"
                      : "icon-home"
                  }`}
                ></span>
                <span className="menu-link-text">Home</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/assign-customer`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/assign-customer`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/assign-customer`
                      ? "icon-user-f"
                      : "icon-user"
                  }`}
                ></span>
                <span className="menu-link-text">Assign Customer</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/apartment-listing`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/apartment-listing`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/apartment-listing`
                      ? "icon-apartment-f"
                      : "icon-apartment"
                  }`}
                ></span>
                <span className="menu-link-text">Apartment</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                // to={`/${isUserType?.replace(/\s/g, "")}/choose-apartment`}
                to={{
                  pathname: `/${isUserType?.replace(
                    /\s/g,
                    "",
                  )}/choose-apartment`,
                  state: { isInventory: true },
                }}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/choose-apartment`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/choose-apartment`
                      ? "icon-apartment-f"
                      : "icon-apartment"
                  }`}
                ></span>
                <span className="menu-link-text">Inventory</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/booking`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/booking`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/booking`
                      ? "icon-booking-f"
                      : "icon-booking"
                  }`}
                ></span>
                <span className="menu-link-text">Bookings</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/payment`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/payment`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/payment`
                      ? "icon-wallet-f"
                      : "icon-wallet"
                  }`}
                ></span>
                <span className="menu-link-text">Payments</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/ebw-lists`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/ebw-lists`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/ebw-lists`
                      ? "icon-ebw-list-f"
                      : "icon-ebw-list"
                  }`}
                ></span>
                <span className="menu-link-text">EBW</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/customer`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/customer`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/customer`
                      ? "icon-user-f"
                      : "icon-user"
                  }`}
                ></span>
                <span className="menu-link-text">Customer</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/user-request`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/user-request`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/user-request`
                      ? "icon-user-request-f"
                      : "icon-user-request"
                  }`}
                ></span>
                <span className="menu-link-text">User Request</span>
              </Link>
            </li>
          </>
        ) : null}
        {isUserType?.replace(/\s/g, "") === commonData?.salesRole ? (
          <>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/dashboard`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/dashboard`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/dashboard`
                      ? "icon-home-f"
                      : "icon-home"
                  }`}
                ></span>
                <span className="menu-link-text">Home</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/customer-search`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/customer-search`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/customer-search`
                      ? "icon-user-f"
                      : "icon-user"
                  }`}
                ></span>
                <span className="menu-link-text">Customer search</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/apartment-listing`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/apartment-listing`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/apartment-listing`
                      ? "icon-apartment-f"
                      : "icon-apartment"
                  }`}
                ></span>
                <span className="menu-link-text">Apartment</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                // to={`/${isUserType?.replace(/\s/g, "")}/choose-apartment`}
                to={{
                  pathname: `/${isUserType?.replace(
                    /\s/g,
                    "",
                  )}/choose-apartment`,
                  state: { isInventory: true },
                }}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/choose-apartment`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/choose-apartment`
                      ? "icon-apartment-f"
                      : "icon-apartment"
                  }`}
                ></span>
                <span className="menu-link-text">Inventory</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/booking`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/booking`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/booking`
                      ? "icon-booking-f"
                      : "icon-booking"
                  }`}
                ></span>
                <span className="menu-link-text">Bookings</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/payment`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/payment`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/payment`
                      ? "icon-wallet-f"
                      : "icon-wallet"
                  }`}
                ></span>
                <span className="menu-link-text">Payments</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/ebw-lists`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/ebw-lists`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/ebw-lists`
                      ? "icon-ebw-list-f"
                      : "icon-ebw-list"
                  }`}
                ></span>
                <span className="menu-link-text">EBW</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/customer`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/customer`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/customer`
                      ? "icon-user-f"
                      : "icon-user"
                  }`}
                ></span>
                <span className="menu-link-text">Customers</span>
              </Link>
            </li>
            {/* <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/user-request`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/user-request`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/user-request`
                      ? "icon-user-request-f"
                      : "icon-user-request"
                  }`}
                ></span>
                <span className="menu-link-text">User Request</span>
              </Link>
            </li> */}
            {/* <li className="menu-item sub-menu">
              <Accordion className="sub-menu-wrap">
                <AccordionSummary
                  expandIcon={
                    <span className="sub-menu-expand-icon  icon-chevron-down">
                    </span>
                  }
                  aria-controls="panel1-content"
                  id="panel1-header"
                  className="sub-menu-head"
                >
                  <a href="#" className="menu-link">
                    <span className="menu-link-icon icon icon-menu"></span>
                    <span className="menu-link-text">More</span>
                  </a>
                </AccordionSummary>
                <AccordionDetails className="sub-menu-cont">
                  <ul className="menu-wrap">
                    <li className="menu-item">
                      <Link
                        to={`/${isUserType?.replace(
                          /\s/g,
                          ""
                        )}/upload-document`}
                        className="menu-link"
                      >
                        <span className="menu-link-text">Document</span>
                      </Link>
                    </li>
                    <li className="menu-item">
                      <Link
                        to={`/${isUserType?.replace(
                          /\s/g,
                          ""
                        )}/choose-apartment-step1"`}
                        className="menu-link"
                      >
                        <span className="menu-link-text">Choose Apartment</span>
                      </Link>
                    </li>
                    <li className="menu-item">
                      <Link href="#" className="menu-link">
                        <span className="menu-link-text">Lorem ipsum</span>
                      </Link>
                    </li>
                  </ul>
                </AccordionDetails>
              </Accordion>
            </li> */}
          </>
        ) : null}
        {isUserType?.replace(/\s/g, "") == commonData?.sourcingTeamLeadRole ? (
          <>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/dashboard`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/dashboard`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/dashboard`
                      ? "icon-home-f"
                      : "icon-home"
                  }`}
                ></span>
                <span className="menu-link-text">Home</span>
              </Link>
            </li>
            {/* <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/assign-customer`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/assign-customer`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/assign-customer`
                      ? "icon-user-f"
                      : "icon-user"
                  }`}
                ></span>
                <span className="menu-link-text">Assign Customer</span>
              </Link>
            </li> */}
            {/* <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/apartment-listing`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/apartment-listing`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/apartment-listing`
                      ? "icon-apartment-f"
                      : "icon-apartment"
                  }`}
                ></span>
                <span className="menu-link-text">Apartment</span>
              </Link>
            </li> */}
            {/* <li className="menu-item">
              <Link
                // to={`/${isUserType?.replace(/\s/g, "")}/choose-apartment`}
                to={{
                  pathname: `/${isUserType?.replace(
                    /\s/g,
                    ""
                  )}/choose-apartment`,
                  state: { isInventory: true },
                }}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/choose-apartment`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/choose-apartment`
                      ? "icon-apartment-f"
                      : "icon-apartment"
                  }`}
                ></span>
                <span className="menu-link-text">Inventory</span>
              </Link>
            </li> */}
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/booking`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/booking`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/booking`
                      ? "icon-booking-f"
                      : "icon-booking"
                  }`}
                ></span>
                <span className="menu-link-text">Bookings</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/payment`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/payment`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/payment`
                      ? "icon-wallet-f"
                      : "icon-wallet"
                  }`}
                ></span>
                <span className="menu-link-text">Payments</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/ebw-lists`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/ebw-lists`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/ebw-lists`
                      ? "icon-ebw-list-f"
                      : "icon-ebw-list"
                  }`}
                ></span>
                <span className="menu-link-text">EBW</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/customer`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/customer`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/customer`
                      ? "icon-user-f"
                      : "icon-user"
                  }`}
                ></span>
                <span className="menu-link-text">Customer</span>
              </Link>
            </li>
          </>
        ) : null}
        {isUserType?.replace(/\s/g, "") === commonData?.sourcingManagerRole ? (
          <>
            {/* <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/dashboard`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/dashboard`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/dashboard`
                      ? "icon-home-f"
                      : "icon-home"
                  }`}
                ></span>
                <span className="menu-link-text">Home</span>
              </Link>
            </li> */}
            {/* <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/apartment-listing`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/apartment-listing`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/apartment-listing`
                      ? "icon-apartment-f"
                      : "icon-apartment"
                  }`}
                ></span>
                <span className="menu-link-text">Apartment</span>
              </Link>
            </li> */}
            {/* <li className="menu-item">
              <Link
                // to={`/${isUserType?.replace(/\s/g, "")}/choose-apartment`}
                to={{
                  pathname: `/${isUserType?.replace(
                    /\s/g,
                    ""
                  )}/choose-apartment`,
                  state: { isInventory: true },
                }}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/choose-apartment`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/choose-apartment`
                      ? "icon-apartment-f"
                      : "icon-apartment"
                  }`}
                ></span>
                <span className="menu-link-text">Inventory</span>
              </Link>
            </li> */}
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/booking`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/booking`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/booking`
                      ? "icon-booking-f"
                      : "icon-booking"
                  }`}
                ></span>
                <span className="menu-link-text">Bookings</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/payment`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/payment`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/payment`
                      ? "icon-wallet-f"
                      : "icon-wallet"
                  }`}
                ></span>
                <span className="menu-link-text">Payments</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/ebw-lists`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/ebw-lists`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/ebw-lists`
                      ? "icon-ebw-list-f"
                      : "icon-ebw-list"
                  }`}
                ></span>
                <span className="menu-link-text">EBW</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/customer`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/customer`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/customer`
                      ? "icon-user-f"
                      : "icon-user"
                  }`}
                ></span>
                <span className="menu-link-text">Customers</span>
              </Link>
            </li>
            {/* <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/user-request`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/user-request`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/user-request`
                      ? "icon-user-request-f"
                      : "icon-user-request"
                  }`}
                ></span>
                <span className="menu-link-text">User Request</span>
              </Link>
            </li> */}
            {/* <li className="menu-item sub-menu">
              <Accordion className="sub-menu-wrap">
                <AccordionSummary
                  expandIcon={
                    <span className="sub-menu-expand-icon  icon-chevron-down">
                    </span>
                  }
                  aria-controls="panel1-content"
                  id="panel1-header"
                  className="sub-menu-head"
                >
                  <a href="#" className="menu-link">
                    <span className="menu-link-icon icon icon-menu"></span>
                    <span className="menu-link-text">More</span>
                  </a>
                </AccordionSummary>
                <AccordionDetails className="sub-menu-cont">
                  <ul className="menu-wrap">
                    <li className="menu-item">
                      <Link
                        to={`/${isUserType?.replace(
                          /\s/g,
                          ""
                        )}/upload-document`}
                        className="menu-link"
                      >
                        <span className="menu-link-text">Document</span>
                      </Link>
                    </li>
                    <li className="menu-item">
                      <Link
                        to={`/${isUserType?.replace(
                          /\s/g,
                          ""
                        )}/choose-apartment-step1"`}
                        className="menu-link"
                      >
                        <span className="menu-link-text">Choose Apartment</span>
                      </Link>
                    </li>
                    <li className="menu-item">
                      <Link href="#" className="menu-link">
                        <span className="menu-link-text">Lorem ipsum</span>
                      </Link>
                    </li>
                  </ul>
                </AccordionDetails>
              </Accordion>
            </li> */}
          </>
        ) : null}
        {isUserType?.replace(/\s/g, "") === commonData?.regionalHead ? (
          <>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/dashboard`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/dashboard`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/dashboard`
                      ? "icon-home-f"
                      : "icon-home"
                  }`}
                ></span>
                <span className="menu-link-text">Home</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/apartment-listing`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/apartment-listing`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/apartment-listing`
                      ? "icon-apartment-f"
                      : "icon-apartment"
                  }`}
                ></span>
                <span className="menu-link-text">Apartment</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                // to={`/${isUserType?.replace(/\s/g, "")}/choose-apartment`}
                to={{
                  pathname: `/${isUserType?.replace(
                    /\s/g,
                    "",
                  )}/choose-apartment`,
                  state: { isInventory: true },
                }}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/choose-apartment`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/choose-apartment`
                      ? "icon-apartment-f"
                      : "icon-apartment"
                  }`}
                ></span>
                <span className="menu-link-text">Inventory</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/booking`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/booking`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/booking`
                      ? "icon-booking-f"
                      : "icon-booking"
                  }`}
                ></span>
                <span className="menu-link-text">Bookings</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/payment`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/payment`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/payment`
                      ? "icon-wallet-f"
                      : "icon-wallet"
                  }`}
                ></span>
                <span className="menu-link-text">Payments</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/ebw-lists`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/ebw-lists`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/ebw-lists`
                      ? "icon-ebw-list-f"
                      : "icon-ebw-list"
                  }`}
                ></span>
                <span className="menu-link-text">EBW</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/customer`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/customer`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/customer`
                      ? "icon-user-f"
                      : "icon-user"
                  }`}
                ></span>
                <span className="menu-link-text">Customers</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/user-request`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/user-request`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/user-request`
                      ? "icon-user-request-f"
                      : "icon-user-request"
                  }`}
                ></span>
                <span className="menu-link-text">User Request</span>
              </Link>
            </li>
            {/* <li className="menu-item sub-menu">
              <Accordion className="sub-menu-wrap">
                <AccordionSummary
                  expandIcon={
                    <span className="sub-menu-expand-icon  icon-chevron-down">
                    </span>
                  }
                  aria-controls="panel1-content"
                  id="panel1-header"
                  className="sub-menu-head"
                >
                  <a href="#" className="menu-link">
                    <span className="menu-link-icon icon icon-menu"></span>
                    <span className="menu-link-text">More</span>
                  </a>
                </AccordionSummary>
                <AccordionDetails className="sub-menu-cont">
                  <ul className="menu-wrap">
                    <li className="menu-item">
                      <Link
                        to={`/${isUserType?.replace(
                          /\s/g,
                          ""
                        )}/upload-document`}
                        className="menu-link"
                      >
                        <span className="menu-link-text">Document</span>
                      </Link>
                    </li>
                    <li className="menu-item">
                      <Link
                        to={`/${isUserType?.replace(
                          /\s/g,
                          ""
                        )}/choose-apartment-step1"`}
                        className="menu-link"
                      >
                        <span className="menu-link-text">Choose Apartment</span>
                      </Link>
                    </li>
                    <li className="menu-item">
                      <Link href="#" className="menu-link">
                        <span className="menu-link-text">Lorem ipsum</span>
                      </Link>
                    </li>
                  </ul>
                </AccordionDetails>
              </Accordion>
            </li> */}
          </>
        ) : null}
        {isUserType?.replace(/\s/g, "") === commonData?.projectHead ? (
          <>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/dashboard`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/dashboard`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/dashboard`
                      ? "icon-home-f"
                      : "icon-home"
                  }`}
                ></span>
                <span className="menu-link-text">Home</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/apartment-listing`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/apartment-listing`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/apartment-listing`
                      ? "icon-apartment-f"
                      : "icon-apartment"
                  }`}
                ></span>
                <span className="menu-link-text">Apartment</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                // to={`/${isUserType?.replace(/\s/g, "")}/choose-apartment`}
                to={{
                  pathname: `/${isUserType?.replace(
                    /\s/g,
                    "",
                  )}/choose-apartment`,
                  state: { isInventory: true },
                }}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/choose-apartment`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/choose-apartment`
                      ? "icon-apartment-f"
                      : "icon-apartment"
                  }`}
                ></span>
                <span className="menu-link-text">Inventory</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/booking`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/booking`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/booking`
                      ? "icon-booking-f"
                      : "icon-booking"
                  }`}
                ></span>
                <span className="menu-link-text">Bookings</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/payment`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/payment`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/payment`
                      ? "icon-wallet-f"
                      : "icon-wallet"
                  }`}
                ></span>
                <span className="menu-link-text">Payments</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/ebw-lists`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/ebw-lists`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/ebw-lists`
                      ? "icon-ebw-list-f"
                      : "icon-ebw-list"
                  }`}
                ></span>
                <span className="menu-link-text">EBW</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/customer`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/customer`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/customer`
                      ? "icon-user-f"
                      : "icon-user"
                  }`}
                ></span>
                <span className="menu-link-text">Customers</span>
              </Link>
            </li>
            {/* <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/user-request`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/user-request`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/user-request`
                      ? "icon-user-request-f"
                      : "icon-user-request"
                  }`}
                ></span>
                <span className="menu-link-text">User Request</span>
              </Link>
            </li> */}
            {/* <li className="menu-item sub-menu">
              <Accordion className="sub-menu-wrap">
                <AccordionSummary
                  expandIcon={
                    <span className="sub-menu-expand-icon  icon-chevron-down">
                    </span>
                  }
                  aria-controls="panel1-content"
                  id="panel1-header"
                  className="sub-menu-head"
                >
                  <a href="#" className="menu-link">
                    <span className="menu-link-icon icon icon-menu"></span>
                    <span className="menu-link-text">More</span>
                  </a>
                </AccordionSummary>
                <AccordionDetails className="sub-menu-cont">
                  <ul className="menu-wrap">
                    <li className="menu-item">
                      <Link
                        to={`/${isUserType?.replace(
                          /\s/g,
                          ""
                        )}/upload-document`}
                        className="menu-link"
                      >
                        <span className="menu-link-text">Document</span>
                      </Link>
                    </li>
                    <li className="menu-item">
                      <Link
                        to={`/${isUserType?.replace(
                          /\s/g,
                          ""
                        )}/choose-apartment-step1"`}
                        className="menu-link"
                      >
                        <span className="menu-link-text">Choose Apartment</span>
                      </Link>
                    </li>
                    <li className="menu-item">
                      <Link href="#" className="menu-link">
                        <span className="menu-link-text">Lorem ipsum</span>
                      </Link>
                    </li>
                  </ul>
                </AccordionDetails>
              </Accordion>
            </li> */}
          </>
        ) : null}
        {isUserType?.replace(/\s/g, "") === commonData?.verticalHead ? (
          <>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/dashboard`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/dashboard`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/dashboard`
                      ? "icon-home-f"
                      : "icon-home"
                  }`}
                ></span>
                <span className="menu-link-text">Home</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/apartment-listing`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/apartment-listing`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/apartment-listing`
                      ? "icon-apartment-f"
                      : "icon-apartment"
                  }`}
                ></span>
                <span className="menu-link-text">Apartment</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/booking`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/booking`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/booking`
                      ? "icon-booking-f"
                      : "icon-booking"
                  }`}
                ></span>
                <span className="menu-link-text">Bookings</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/payment`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/payment`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/payment`
                      ? "icon-wallet-f"
                      : "icon-wallet"
                  }`}
                ></span>
                <span className="menu-link-text">Payments</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/ebw-lists`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/ebw-lists`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/ebw-lists`
                      ? "icon-ebw-list-f"
                      : "icon-ebw-list"
                  }`}
                ></span>
                <span className="menu-link-text">EBW</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/customer`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/customer`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/customer`
                      ? "icon-user-f"
                      : "icon-user"
                  }`}
                ></span>
                <span className="menu-link-text">Customers</span>
              </Link>
            </li>
            {/* <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/user-request`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/user-request`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/user-request`
                      ? "icon-user-request-f"
                      : "icon-user-request"
                  }`}
                ></span>
                <span className="menu-link-text">User Request</span>
              </Link>
            </li> */}
            {/* <li className="menu-item sub-menu">
              <Accordion className="sub-menu-wrap">
                <AccordionSummary
                  expandIcon={
                    <span className="sub-menu-expand-icon  icon-chevron-down">
                    </span>
                  }
                  aria-controls="panel1-content"
                  id="panel1-header"
                  className="sub-menu-head"
                >
                  <a href="#" className="menu-link">
                    <span className="menu-link-icon icon icon-menu"></span>
                    <span className="menu-link-text">More</span>
                  </a>
                </AccordionSummary>
                <AccordionDetails className="sub-menu-cont">
                  <ul className="menu-wrap">
                    <li className="menu-item">
                      <Link
                        to={`/${isUserType?.replace(
                          /\s/g,
                          ""
                        )}/upload-document`}
                        className="menu-link"
                      >
                        <span className="menu-link-text">Document</span>
                      </Link>
                    </li>
                    <li className="menu-item">
                      <Link
                        to={`/${isUserType?.replace(
                          /\s/g,
                          ""
                        )}/choose-apartment-step1"`}
                        className="menu-link"
                      >
                        <span className="menu-link-text">Choose Apartment</span>
                      </Link>
                    </li>
                    <li className="menu-item">
                      <Link href="#" className="menu-link">
                        <span className="menu-link-text">Lorem ipsum</span>
                      </Link>
                    </li>
                  </ul>
                </AccordionDetails>
              </Accordion>
            </li> */}
          </>
        ) : null}
        {isUserType?.replace(/\s/g, "") === commonData?.subVerticalHead ? (
          <>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/dashboard`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/dashboard`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/dashboard`
                      ? "icon-home-f"
                      : "icon-home"
                  }`}
                ></span>
                <span className="menu-link-text">Home</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/apartment-listing`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/apartment-listing`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/apartment-listing`
                      ? "icon-apartment-f"
                      : "icon-apartment"
                  }`}
                ></span>
                <span className="menu-link-text">Apartment</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/booking`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/booking`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/booking`
                      ? "icon-booking-f"
                      : "icon-booking"
                  }`}
                ></span>
                <span className="menu-link-text">Bookings</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/payment`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/payment`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/payment`
                      ? "icon-wallet-f"
                      : "icon-wallet"
                  }`}
                ></span>
                <span className="menu-link-text">Payments</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/ebw-lists`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/ebw-lists`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/ebw-lists`
                      ? "icon-ebw-list-f"
                      : "icon-ebw-list"
                  }`}
                ></span>
                <span className="menu-link-text">EBW</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/customer`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/customer`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/customer`
                      ? "icon-user-f"
                      : "icon-user"
                  }`}
                ></span>
                <span className="menu-link-text">Customers</span>
              </Link>
            </li>
            {/* <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/user-request`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/user-request`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/user-request`
                      ? "icon-user-request-f"
                      : "icon-user-request"
                  }`}
                ></span>
                <span className="menu-link-text">User Request</span>
              </Link>
            </li> */}
            {/* <li className="menu-item sub-menu">
              <Accordion className="sub-menu-wrap">
                <AccordionSummary
                  expandIcon={
                    <span className="sub-menu-expand-icon  icon-chevron-down">
                    </span>
                  }
                  aria-controls="panel1-content"
                  id="panel1-header"
                  className="sub-menu-head"
                >
                  <a href="#" className="menu-link">
                    <span className="menu-link-icon icon icon-menu"></span>
                    <span className="menu-link-text">More</span>
                  </a>
                </AccordionSummary>
                <AccordionDetails className="sub-menu-cont">
                  <ul className="menu-wrap">
                    <li className="menu-item">
                      <Link
                        to={`/${isUserType?.replace(
                          /\s/g,
                          ""
                        )}/upload-document`}
                        className="menu-link"
                      >
                        <span className="menu-link-text">Document</span>
                      </Link>
                    </li>
                    <li className="menu-item">
                      <Link
                        to={`/${isUserType?.replace(
                          /\s/g,
                          ""
                        )}/choose-apartment-step1"`}
                        className="menu-link"
                      >
                        <span className="menu-link-text">Choose Apartment</span>
                      </Link>
                    </li>
                    <li className="menu-item">
                      <Link href="#" className="menu-link">
                        <span className="menu-link-text">Lorem ipsum</span>
                      </Link>
                    </li>
                  </ul>
                </AccordionDetails>
              </Accordion>
            </li> */}
          </>
        ) : null}
        {isUserType?.replace(/\s/g, "") === commonData?.CRM ? (
          <>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/dashboard`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/dashboard`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/dashboard`
                      ? "icon-home-f"
                      : "icon-home"
                  }`}
                ></span>
                <span className="menu-link-text">Home</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/booking`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/booking`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/booking`
                      ? "icon-booking-f"
                      : "icon-booking"
                  }`}
                ></span>
                <span className="menu-link-text">Bookings</span>
              </Link>
            </li>
            {/* <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/apartment-listing`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/apartment-listing`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/apartment-listing`
                      ? "icon-apartment-f"
                      : "icon-apartment"
                  }`}
                ></span>
                <span className="menu-link-text">Apartment</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/booking`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/booking`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/booking`
                      ? "icon-booking-f"
                      : "icon-booking"
                  }`}
                ></span>
                <span className="menu-link-text">Bookings</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/payment`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/payment`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/payment`
                      ? "icon-wallet-f"
                      : "icon-wallet"
                  }`}
                ></span>
                <span className="menu-link-text">Payments</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/ebw-lists`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/ebw-lists`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/ebw-lists`
                      ? "icon-ebw-list-f"
                      : "icon-ebw-list"
                  }`}
                ></span>
                <span className="menu-link-text">EBW</span>
              </Link>
            </li>
            <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/customer`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/customer`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/customer`
                      ? "icon-user-f"
                      : "icon-user"
                  }`}
                ></span>
                <span className="menu-link-text">Customers</span>
              </Link>
            </li> */}
            {/* <li className="menu-item">
              <Link
                to={`/${isUserType?.replace(/\s/g, "")}/user-request`}
                className={`menu-link ${
                  history.location.pathname ===
                  `/${isUserType?.replace(/\s/g, "")}/user-request`
                    ? "active"
                    : ""
                }`}
                onClick={handleMenuClick}
              >
                <span
                  className={`menu-link-icon icon ${
                    history.location.pathname ===
                    `/${isUserType?.replace(/\s/g, "")}/user-request`
                      ? "icon-user-request-f"
                      : "icon-user-request"
                  }`}
                ></span>
                <span className="menu-link-text">User Request</span>
              </Link>
            </li> */}
            {/* <li className="menu-item sub-menu">
              <Accordion className="sub-menu-wrap">
                <AccordionSummary
                  expandIcon={
                    <span className="sub-menu-expand-icon  icon-chevron-down"></span>
                  }
                  aria-controls="panel1-content"
                  id="panel1-header"
                  className="sub-menu-head"
                >
                  <a href="#" className="menu-link">
                    <span className="menu-link-icon icon icon-menu"></span>
                    <span className="menu-link-text">More</span>
                  </a>
                </AccordionSummary>
                <AccordionDetails className="sub-menu-cont">
                  <ul className="menu-wrap">
                    <li className="menu-item">
                      <Link
                        to={`/${isUserType?.replace(
                          /\s/g,
                          ""
                        )}/upload-document`}
                        className="menu-link"
                      >
                        <span className="menu-link-text">Document</span>
                      </Link>
                    </li>
                    <li className="menu-item">
                      <Link
                        to={`/${isUserType?.replace(
                          /\s/g,
                          ""
                        )}/choose-apartment-step1"`}
                        className="menu-link"
                      >
                        <span className="menu-link-text">Choose Apartment</span>
                      </Link>
                    </li>
                    <li className="menu-item">
                      <Link href="#" className="menu-link">
                        <span className="menu-link-text">Lorem ipsum</span>
                      </Link>
                    </li>
                  </ul>
                </AccordionDetails>
              </Accordion>
            </li> */}
          </>
        ) : null}
      </ul>
      {!isMenuOpen && <span className="hovered-item" id="hover-text"></span>}
      <ul className="menu-wrap">
        {/* <li className="menu-item">
          <a href="#" className="menu-link">
            <span className="menu-link-icon icon icon-support"></span>
            <span className="menu-link-text">Help & Support</span>
          </a>
        </li>
        <li className="menu-item">
          <a href="/login" className="menu-link" onClick={handleSignOut}>
            <span className="menu-link-icon icon icon-logout"></span>
            <span className="menu-link-text">Sign out</span>
          </a>
        </li> */}
      </ul>
    </nav>
  );
}

export default Menu;
